// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import styled from 'styled-components';

const StyledIdeasContainer = styled.div`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;

  padding: 30px 20px;
  background: #ffffff;
  padding: 20px;
  border: 1px solid #d9d9d9;
`;

const StyledIdea = styled.div`
    margin-bottom: 20px;
    cursor: pointer;
    max-width: 200px;
    margin-right: 20px;
    img {
        display: block
        width: 199px;
        height: 120px;
        margin-bottom: 5px;
    }
    
    div {
        margin-left: 5px;
        font-size: 14px; 
        overflow: hidden;
        text-overflow: ellipsis;
    } 
`;

const EventTemplatesWrapper = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  templates,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  onTemplateClick,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  originalData,
}) => (
  <StyledIdeasContainer>
    {/* TODO: Fix this the next time the file is edited. */}
    {/* eslint-disable-next-line react/prop-types */}
    {templates.map((template, index) => (
      <StyledIdea
        key={template.title}
        onClick={() => onTemplateClick(originalData[index])}
      >
        <img src={template.src} alt={template.title} />
        <div>{template.title}</div>
      </StyledIdea>
    ))}
  </StyledIdeasContainer>
);

export default EventTemplatesWrapper;
